module.exports = __webpack_public_path__ + "img/testimonial-bg.571afa7f.jpg";